import UIFlex from 'UIComponents/layout/UIFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function Error({
  errors
}) {
  return /*#__PURE__*/_jsx(UIFlex, {
    direction: "column",
    align: "center",
    gap: 18,
    className: "m-top-7 m-bottom-8",
    children: /*#__PURE__*/_jsx(UIErrorMessage, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "messaging-insights.insights.error.default"
      }),
      children: /*#__PURE__*/_jsxs("p", {
        children: [errors.message, "."]
      })
    })
  });
}
export default Error;